module.exports = __webpack_public_path__ + "img/bg-cant-find@2x.a1a951d3.webp";